const clubsdata = {
    club : [
        {id:1,image:'Images/clublogo/coding.jpeg',club:'Coding',sirname:'Club',sec:'Mugdha Sharma',jsec:'Aniruddh Modi'},
        {id:2,image:'Images/clublogo/shades.jpeg',club:'Shades',sirname:'',sec:'Vranda Mahajan',jsec:'DEF'},
        {id:3,image:'Images/clublogo/masquerade.jpeg',club:'Masquerade',sirname:'',sec:'Aradhya Mishra , Rajan Kumar Panjira',jsec:'Chavvi Gupta'},
        {id:4,image:'Images/clublogo/mod5.jpeg',club:'Mod5',sirname:'',sec:'Anisha Katiyar',jsec:'Arya Bhatt'},
        {id:5,image:'Images/clublogo/encore.jpeg',club:'Encore',sirname:'',sec:'Suryansh Shukla',jsec:'Ansh Zala'},
        {id:6,image:'Images/clublogo/arcadia.jpg',club:'Arcadia',sirname:'',sec:'Sahil Kumar Rai',jsec:'Shubham Mehatre'},
        {id:7,image:'Images/clublogo/obscura.jpeg',club:'Obscura',sirname:'',sec:'Chetan Verma',jsec:'Nishant Dev'},
        {id:8,image:'Images/clublogo/literature.jpeg',club:'Literature',sirname:'Club',sec:'Tejas Joshi',jsec:'Dhruv Sharma'},
        {id:9,image:'Images/clublogo/dot.jpeg',club:'Dot',sirname:'Club',sec:'Suyash Jain',jsec:'Sanidhya Kumar '},
        {id:10,image:'Images/clublogo/finance.jpeg',club:'Finance and Consulting ',sirname:'Club',sec:'Vansh Goel',jsec:'Snehal Nalawade'},
        {id:11,image:'Images/clublogo/iot.jpg',club:'IoT',sirname:'Club',sec:'ABC',jsec:'DEF'},

    ]
}

const clubReducer =(state=clubsdata,action)=>{
    return state;
}


export default clubReducer